const hasMatchingSlug = (slugValues1, slugValues2) => {
  // If both variables are arrays
  if (Array.isArray(slugValues1) && Array.isArray(slugValues2)) {
    return slugValues1.find(slug1 => {
      return slugValues2.includes(slug1)
    })
  } else if (typeof slugValues1 === 'string' && Array.isArray(slugValues2)) {
    // If 1 is string and 2 is array
    return slugValues2.find(slug => slug === slugValues1)
  } else if (Array.isArray(slugValues1) && typeof slugValues2 === 'string') {
    // If 1 is array and 2 is string
    return slugValues1.find(slug => slug === slugValues2)
  } else if (typeof slugValues1 === 'string' && typeof slugValues2 === 'string') {
    // If both are string
    return slugValues1 === slugValues2 ? slugValues1 : false
  }
  return false
}

const cleanKeyword = (keyword) => {
  return keyword ? keyword.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"') : ''
}

export { hasMatchingSlug, cleanKeyword }
